import { Link } from "react-router-dom";
import { Camera, Video, Plane, LayoutDashboard, Eye, User, Building2 } from "lucide-react";
import servicePhoto from "@/assets/service-photo.jpg";
import serviceVideo from "@/assets/service-video.jpg";
import serviceDrone from "@/assets/service-drone.jpg";
import serviceVirtual from "@/assets/service-virtual.jpg";
import serviceBranding from "@/assets/service-branding.jpg";
import serviceFloorPlan from "@/assets/portfolio/gigharbor-5.jpg";
import serviceCommercial from "@/assets/portfolio/gigharbor-1.jpg";

const servicesPreview = [
  {
    slug: "real-estate-photography",
    title: "Real Estate Photography",
    description: "HDR photography that captures every detail with professional lighting and composition.",
    icon: Camera,
    image: servicePhoto,
  },
  {
    slug: "real-estate-video",
    title: "Cinematic Video",
    description: "4K video tours with smooth stabilization that create emotional connections with buyers.",
    icon: Video,
    image: serviceVideo,
  },
  {
    slug: "drone-photography",
    title: "Drone / Aerial",
    description: "Stunning aerial perspectives showcasing property, land, and surrounding neighborhood.",
    icon: Plane,
    image: serviceDrone,
  },
  {
    slug: "floor-plans",
    title: "Floor Plans",
    description: "Accurate 2D and 3D floor plans that help buyers understand space and flow.",
    icon: LayoutDashboard,
    image: serviceFloorPlan,
  },
  {
    slug: "virtual-tours",
    title: "Virtual Tours",
    description: "Immersive 3D tours that let buyers explore properties from anywhere in the world.",
    icon: Eye,
    image: serviceVirtual,
  },
  {
    slug: "commercial-architecture",
    title: "Commercial / Architecture",
    description: "Professional imagery for commercial properties, offices, retail, and architectural projects.",
    icon: Building2,
    image: serviceCommercial,
  },
  {
    slug: "agent-branding",
    title: "Headshots & Branding",
    description: "Professional headshots and branded content to elevate your personal image.",
    icon: User,
    image: serviceBranding,
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-secondary">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">
            What We Offer
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-semibold text-foreground mb-6">
            Premium Real Estate Media Services
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            A full suite of visual marketing solutions designed to make your listings 
            stand out and sell faster.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {servicesPreview.map((service, index) => (
            <Link
              key={service.slug}
              to={`/services/${service.slug}`}
              className="group relative overflow-hidden rounded-lg bg-card border border-border hover:border-primary/50 transition-all duration-500 hover:-translate-y-1 hover:shadow-gold"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-card via-card/60 to-transparent" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="p-2 rounded-full bg-primary/20 text-primary">
                    <service.icon size={20} />
                  </div>
                  <h3 className="font-serif text-xl font-semibold text-foreground group-hover:text-primary transition-colors">
                    {service.title}
                  </h3>
                </div>
                <p className="text-muted-foreground text-sm">
                  {service.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
